import React from "react";
import { FormControlLabel, Switch, Typography } from "@mui/material";

export const CompressToggle = ({ compressView, onChange }) => {
  if (typeof onChange !== "function") return null;

  return (
      <FormControlLabel
      sx={{ mr: 0, ml: 0 }}
        control={
          <Switch
          size="small"
            checked={compressView}
            onChange={(e) => onChange(e.target.checked)}
            color="primary"
          />
        }
      label={
        <Typography variant="body2">Hide Empty Rows</Typography>
      }
      />
  );
};
